import { get, put, post } from './Tools';

const UMA_ID = 'UMA';

const getListAreas = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}area_trabajo/get/list`);
  return response;
};

const getEmpleados = async (ids) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo/empleados/get/ids`, ids);
  return response;
}

const getEmpleadosActivos = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/activos`);
  return response;
}

const getUMA = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_detalle/recent/${UMA_ID}`);
  return response;
}

const getDepartamentos = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/list`);
  return response;
}

const getEmpleadosByDepartamento = async (department_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/departamento/${department_id}`);
  return response;
}

const getEmpleadosByArea = async (area_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/area/${area_id}`);
  return response;
}

const getIncapacitados = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}incapacidad_empleado`);
  return response;
}

const getSalarioDiarioIntegrado = async (empleado_id, fecha_actual) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_integrado/get/salario-diario-integrado?empleado_id=${empleado_id}&fecha_actual=${fecha_actual}`);
  return response;
};

const getSalarioDiarioIntegradoDirecto = async (salario_diario, factor_integracion, variable, fijo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_integrado/get/salario-diario-integrado-directo?salario_diario=${salario_diario}&factor_integracion=${factor_integracion}&variable=${variable}&fijo=${fijo}`);
  return response;
};

const getFactorIntegracion = async (fecha_actual, fecha_ingreso, integracion_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_integrado/get/factor-integracion?fecha_actual=${fecha_actual}&fecha_ingreso=${fecha_ingreso}&integracion_id=${integracion_id}`);
  return response;
};

const aplicarCalculoIntegradoEmpleado = async (empleado_id, fecha_actual, comentario) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_integrado/empleado/${empleado_id}/aplicar`,
    {
      fecha_actual,
      comentario,
    }
  );
  return response;
};

const previewActualizacionSalarialEmpleado = async (empleado_id, payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_integrado/empleado/${empleado_id}/preview-salario`, payload);
  return response;
};

const aplicarActualizacionSalarialEmpleado = async (empleado_id, payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_integrado/empleado/${empleado_id}/actualizar-salario`, payload);
  return response;
};


export { getListAreas, getEmpleados, getUMA, getDepartamentos, getEmpleadosByDepartamento, getEmpleadosByArea, getIncapacitados, getSalarioDiarioIntegrado, getSalarioDiarioIntegradoDirecto, getFactorIntegracion, aplicarCalculoIntegradoEmpleado, previewActualizacionSalarialEmpleado, aplicarActualizacionSalarialEmpleado, getEmpleadosActivos };